export default __webpack_public_path__ + "static/media/icon_add_user.cbf8e58b.svg";